<template>
    <header
        class="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur"
    >
        <nav
            class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"
            aria-label="Primary navigation"
        >
            <input
                id="mobile-menu-toggle"
                type="checkbox"
                class="peer sr-only md:hidden"
            />

            <div class="flex h-16 items-center justify-between">
                <a
                    :href="landingHomePageUrl"
                    class="flex items-center gap-2"
                    :aria-label="`${appName} home`"
                >
                    <picture>
                        <Image
                            src="/favicon.svg"
                            alt=""
                            aria-hidden="true"
                            class="h-6 w-6 shrink-0 object-contain"
                        />
                    </picture>
                    <span class="text-lg font-bold tracking-tight">
                        {{ appName }}
                    </span>
                </a>

                <div class="flex items-center gap-2 md:hidden">
                    <a
                        :href="authLoginUrl"
                        class="rounded-lg px-3 py-2 text-sm font-bold text-slate-700 hover:bg-slate-100"
                    >
                        Login
                    </a>

                    <button
                        type="button"
                        class="inline-flex items-center justify-center rounded-lg p-2 text-slate-700 hover:bg-slate-100"
                        aria-controls="mobile-navigation"
                        aria-label="Toggle navigation menu"
                        onclick="
                            document
                                .getElementById('mobile-menu-toggle')
                                .toggleAttribute('checked')
                        "
                    >
                        <LandingPageIcon
                            name="menu"
                            class="h-6 w-6"
                            aria-hidden="true"
                        />
                    </button>
                </div>

                <div class="hidden items-center gap-8 md:flex">
                    <ul
                        class="flex items-center gap-6 text-sm font-bold text-slate-700"
                        aria-label="Page sections"
                    >
                        <li
                            v-for="link in primaryLinks"
                            :key="link.label"
                        >
                            <a
                                :href="link.href"
                                class="hover:text-slate-900"
                            >
                                {{ link.label }}
                            </a>
                        </li>
                    </ul>

                    <ul
                        class="flex gap-1"
                        aria-label="Account links"
                    >
                        <li>
                            <a
                                :href="authLoginUrl"
                                class="rounded-lg px-3 py-2 text-sm font-bold text-slate-700 hover:bg-slate-100"
                            >
                                Login
                            </a>
                        </li>
                        <li>
                            <a
                                :href="desktopRegisterUrl"
                                class="rounded-lg bg-primary px-4 py-2 text-sm font-bold text-white shadow-xs shadow-primary-shade-ligth hover:bg-primary-shade"
                            >
                                Start free
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div
                id="mobile-navigation"
                data-markdown-hidden
                class="hidden peer-checked:md:hidden peer-checked:block w-full border-t border-slate-200 pb-4 pt-2"
            >
                <ul class="flex flex-col gap-1">
                    <li
                        v-for="link in primaryLinks"
                        :key="link.label"
                    >
                        <a
                            :href="link.href"
                            class="block rounded-lg px-3 py-2 text-sm font-bold text-slate-700 hover:bg-slate-100"
                            onclick="
                                document
                                    .getElementById('mobile-menu-toggle')
                                    .removeAttribute('checked')
                            "
                        >
                            {{ link.label }}
                        </a>
                    </li>
                </ul>

                <ul class="mt-2 flex gap-2">
                    <li class="flex-1">
                        <a
                            :href="authLoginUrl"
                            class="block rounded-lg border border-slate-200 px-3 py-2 text-center text-sm font-bold text-slate-700 hover:bg-slate-50"
                        >
                            Login
                        </a>
                    </li>
                    <li class="flex-1">
                        <a
                            :href="mobileRegisterUrl"
                            class="block rounded-lg bg-primary px-3 py-2 text-center text-sm font-bold text-white hover:bg-primary-shade"
                        >
                            Start free
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>

<script setup lang="ts">
    import { UtmContentEnum } from '@/Shared/Service/Tracking/Utm/UtmEnums'
    import Image from '@/Shared/Component/Image.vue'
    import LandingPageIcon from '@/Marketing/LandingPage/Component/LandingPageIcon.vue'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    defineProps({
        appName: {
            type: String,
            required: true,
        },
    })

    const urlFactory = new UrlFactory()
    const authLoginUrl = urlFactory.makeAuthLoginPageUrl()
    const desktopRegisterUrl = urlFactory.makeLandingPageRegisterUrl(
        UtmContentEnum.LandingPageDesktopNavigation,
    )
    const mobileRegisterUrl = urlFactory.makeLandingPageRegisterUrl(
        UtmContentEnum.LandingPageMobileNavigation,
    )
    const landingHomePageUrl = urlFactory.makeLandingHomePageUrl()
    const primaryLinks = [
        { href: urlFactory.makeLandingDemoSectionPageUrl(), label: 'Demo' },
        {
            href: urlFactory.makeLandingFeaturesSectionPageUrl(),
            label: 'Features',
        },
        {
            href: urlFactory.makeLandingPricingSectionPageUrl(),
            label: 'Pricing',
        },
        { href: urlFactory.makeLandingFaqSectionPageUrl(), label: 'FAQ' },
    ]
</script>
